<div>
  <div style="width: 100%; display: flex">
    <div class="col-sm-6 col-md-6" [ngClass]="{ 'col-md-6': !hideTabs, 'col-md-8': hideTabs }">
      <div style="display: flex">
        <h1 class="aru-title">{{ title }}</h1>
        <a *ngIf="canEdit" [routerLink]="[CreateUrl]" class="btn aru btn-primary no-wrap">Create new</a>
        <div class="aru-search" *ngIf="canSimpleSearch">
          <app-inspection-filter-cards
            *ngIf="setInspectionSearch"
            (searchTermUpdated)="setSearchTerm($event)"
            style="flex: 1; max-width: 13rem"></app-inspection-filter-cards>

          <div *ngIf="!setInspectionSearch" class="input-group">
            <input
              type="text"
              class="form-control"
              [placeholder]="SearchPlaceholder ? SearchPlaceholder : 'Search'"
              [(ngModel)]="searchString"
              (ngModelChange)="setSearch()" />
            <div class="input-group-append close" *ngIf="searchString" (click)="searchString = ''; setSearch()">
              <span><i class="fa fa-close"></i></span>
            </div>
            <div class="input-group-append search" *ngIf="!searchString">
              <span><i class="fa fa-search"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-6">
      <tabs
        [hide]="hideTabs"
        [type]="tabType"
        [title]="title"
        [tabsName]="tabsName"
        (tabChanged)="tabChanged($event)"
        #tabs
        active="{{ type }}"></tabs>
    </div>
  </div>
  <span style="margin-left: 1.5rem; display: block">
    <app-search-filter
      *ngIf="canAdvanceSearch && definedFilters && definedFilters.length > 0"
      [filters]="definedFilters"
      (filtersUpdated)="filtersUpdated($event)"
      [params]="parms"></app-search-filter>
  </span>
  <br />

  <div *ngIf="true" class="table-wrapper">
    <table class="table aru pointer">
      <thead>
        <tr>
          <th *ngFor="let row of column" (click)="setOrder(row.orderBy)">
            {{ row.header }}
            <i *ngIf="canOrder && row.orderBy" class="fa" [ngClass]="getOrderIcon(row.orderBy)"></i>
          </th>

          <th *ngIf="canEdit && showAction">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data" (click)="open($event, item.id)">
          <td *ngFor="let column of column">
            <span *ngIf="column.type == 'text'">
              {{ getRowData(item, column.field) }}
            </span>
            <span *ngIf="column.type == 'text-with-default'">
              {{ getRowData(item, column.field) ? getRowData(item, column.field) : column?.default }}
            </span>
            <span *ngIf="column.type == 'html'" [innerHTML]="getRowData(item, column.field)"> </span>
            <span *ngIf="column.type == 'link'" (click)="$event.stopPropagation()">
              <a [routerLink]="getLink(item, column)">
                {{ getRowData(item, column.field) }}
              </a>
            </span>
            <span class="text-nowrap" *ngIf="column.type == 'date/time'">
              <a>
                {{ getDateAndTime(getRowData(item, column.field)) }}
              </a>
            </span>
            <span class="text-nowrap" *ngIf="column.type == 'date'">
              <a>
                {{ dateAsString(getRowData(item, column.field)) }}
              </a>
            </span>

            <span
              class="text-nowrap"
              *ngIf="column.type == 'tooltip'"
              class="aru-has-tooltip"
              style="min-width: 230px; max-width: 0">
              <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                {{ getRowData(item, column.field) }}
              </div>
              <span class="aru-tooltip">
                {{ getRowData(item, column.tooltip) }}
              </span>
            </span>

            <span class="text-nowrap" *ngIf="column.type == 'ConditionOnAction'">
              <button
                *ngIf="!getRowData(item, column.field)"
                class="btn btn-link"
                style="padding: 6px 0"
                (click)="executeFieldAction(column.action, $event, item)">
                Assign
              </button>
              <span *ngIf="getRowData(item, column.field)">{{ getRowData(item, column.field) }}</span>
            </span>
            <span *ngIf="column.type == 'downloadReport'">
              <button
                type="button"
                (click)="createReport($event, item)"
                class="aru btn btn-primary"
                style="width: unset">
                <i class="fa fa-cloud-download fa-lg"></i>
              </button>
            </span>
          </td>
          <td *ngIf="canEdit && showAction" (click)="$event.stopPropagation()">
            <div class="dropdown" dropdown>
              <button type="button" class="btn" dropdownToggle>
                <i class="fa fa-ellipsis-h"></i>
              </button>
              <div class="dropdown-menu right" *dropdownMenu>
                <ng-container *ngFor="let action of actions[type]">
                  <a class="dropdown-item" *ngIf="action.show(item)()" (click)="executeAction(action, item)">{{
                    action.label
                  }}</a>
                </ng-container>
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td
            *ngIf="!data?.length && !loading"
            [attr.colspan]="column?.length + (canEdit ? 1 : 0)"
            style="text-align: center">
            No records were found.
          </td>
          <div *ngIf="loading">
            <ngx-loading
              [show]="loading"
              [config]="{
                backdropBorderRadius: '3px',
                animationType: ngxLoadingAnimationTypes.threeBounce,
                primaryColour: this.primaryColour,
                secondaryColour: this.secondaryColour
              }">
            </ngx-loading>
          </div>
        </tr>
      </tbody>
    </table>
  </div>
  <div [class.pagination-disabled]="loading || navigating">
    <pagination
      *ngIf="count"
      class="pagination"
      [(ngModel)]="page"
      [totalItems]="count"
      [itemsPerPage]="pageSize"
      [maxSize]="5"
      [boundaryLinks]="true"
      [rotate]="false"
      (pageChanged)="onPageChanged($event.page)">
    </pagination>
  </div>
</div>
